import React from 'react';

export const ClickAwayContext = React.createContext({
  onClickAway: () => {},
});
